import { Injectable, inject } from "@angular/core";
import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Planner } from "@app/models/rest/planner";
import { PlannerRestService } from "@app/services/hal/planner-rest-service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class PlannerStore extends RealTimeDataStore<Planner> {
  constructor() {
    const plannerRestService = inject(PlannerRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(plannerRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("Planner");
  }
}
